module.exports = __webpack_public_path__ + "media/video_m_ja.0882a545.mp4";